import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, withModifiers as _withModifiers, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "px-6 md:px-8 pt-6 overflow-x-clip" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "text-gray-900 font-medium truncate" }
const _hoisted_4 = { class: "truncate" }
const _hoisted_5 = { class: "flex justify-end" }

import { XCircleIcon } from '@heroicons/vue/24/outline'
import _ from 'lodash'
import { computed, ref } from 'vue'

import EmptyState from '@/components/neue/EmptyState.vue'
import NeueWell from '@/components/neue/NeueWell.vue'
import TablistGrid from '@/components/neue/TablistGrid.vue'
import api from '@/store/api'
import { mapType } from '@/store/mappers'


export default {
  __name: 'ProductFolders',
  setup(__props) {

const loading = ref(true)
const modalOpen = ref(false)
const folderName = ref('')

const folders = computed(() => mapType('folder'))

const createFolder = () => {
  api.call('POST', 'folders', {
    folder: { name: folderName.value }
  })
  folderName.value = ''
  modalOpen.value = false
}

const deleteFolder = folder => {
  if (!confirm(`Delete ${folder.attributes.name}?`)) return
  api.call('DELETE', `folders/${folder.id}`)
}

api.call('GET', 'folders?included=folder_items').then(() => {
  loading.value = false
})

return (_ctx, _cache) => {
  const _component_NeueButton = _resolveComponent("NeueButton")
  const _component_SecondaryTop = _resolveComponent("SecondaryTop")
  const _component_InputField = _resolveComponent("InputField")
  const _component_FormElement = _resolveComponent("FormElement")
  const _component_FormSection = _resolveComponent("FormSection")
  const _component_TheModal = _resolveComponent("TheModal")
  const _component_TablistHeader = _resolveComponent("TablistHeader")
  const _component_TablistRow = _resolveComponent("TablistRow")
  const _component_NeueTablist = _resolveComponent("NeueTablist")
  const _component_NeueLoading = _resolveComponent("NeueLoading")
  const _component_SecondaryNav = _resolveComponent("SecondaryNav")

  return (_openBlock(), _createBlock(_component_SecondaryNav, null, {
    top: _withCtx(() => [
      _createVNode(_component_SecondaryTop, { text: "Folders" }, {
        right: _withCtx(() => [
          _createVNode(_component_NeueButton, {
            type: "primary",
            onClick: _cache[0] || (_cache[0] = $event => (modalOpen.value = true))
          }, {
            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
              _createTextVNode("New", -1)
            ]))]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    main: _withCtx(() => [
      _createVNode(_component_TheModal, {
        "is-open": modalOpen.value,
        "modal-title": "New folder",
        onCloseModal: _cache[4] || (_cache[4] = $event => (modalOpen.value = false))
      }, {
        main: _withCtx(() => [
          _createVNode(_component_FormSection, null, {
            default: _withCtx(() => [
              _createVNode(_component_FormElement, null, {
                default: _withCtx(() => [
                  _createVNode(_component_InputField, {
                    modelValue: folderName.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((folderName).value = $event)),
                    placeholder: "Name",
                    onKeydown: _cache[2] || (_cache[2] = _withKeys($event => (folderName.value && createFolder()), ["enter"]))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        footer: _withCtx(() => [
          _createVNode(_component_NeueButton, {
            type: "secondary",
            onClick: _cache[3] || (_cache[3] = $event => (modalOpen.value = false))
          }, {
            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
              _createTextVNode("Cancel", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_NeueButton, {
            type: folderName.value ? 'primary' : 'inactive',
            onClick: createFolder
          }, {
            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
              _createTextVNode("Add", -1)
            ]))]),
            _: 1
          }, 8, ["type"])
        ]),
        default: _withCtx(() => [
          _cache[8] || (_cache[8] = _createTextVNode(" > ", -1))
        ]),
        _: 1
      }, 8, ["is-open"]),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_NeueLoading, { loading: loading.value }, {
          default: _withCtx(() => [
            (folders.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(_component_NeueTablist, null, {
                    head: _withCtx(() => [
                      _createVNode(_component_TablistHeader, null, {
                        default: _withCtx(() => [
                          _createVNode(TablistGrid, {
                            columns: ['Name', 'Products', ''],
                            header: ""
                          }, {
                            default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                              _createElementVNode("div", null, "Name", -1),
                              _createElementVNode("div", null, "Products", -1),
                              _createElementVNode("div", null, null, -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(folders.value, (folder) => {
                        return (_openBlock(), _createBlock(_component_TablistRow, {
                          key: folder.id
                        }, {
                          default: _withCtx(() => [
                            _createVNode(TablistGrid, {
                              columns: ['Name', 'Products', ''],
                              class: "items-center"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_3, _toDisplayString(folder.attributes.name), 1),
                                _createElementVNode("div", _hoisted_4, _toDisplayString(folder.relationships.folder_items.data.length) + " product" + _toDisplayString(folder.relationships.folder_items.data.length === 1 ? '' : 's'), 1),
                                _createElementVNode("div", _hoisted_5, [
                                  _createVNode(_unref(XCircleIcon), {
                                    class: "h-5 w-5 cursor-pointer text-gray-700",
                                    onClick: _withModifiers($event => (deleteFolder(folder)), ["stop"])
                                  }, null, 8, ["onClick"])
                                ])
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            (!folders.value.length && !loading.value)
              ? (_openBlock(), _createBlock(NeueWell, {
                  key: 1,
                  class: "text-center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(EmptyState, { plural: "folders" })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    _: 1
  }))
}
}

}